import { render } from "./06_Acces.vue?vue&type=template&id=54fc44d6&scoped=true"
import script from "./06_Acces.vue?vue&type=script&lang=js"
export * from "./06_Acces.vue?vue&type=script&lang=js"

import "./06_Acces.vue?vue&type=style&index=0&id=54fc44d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fc44d6"]])

export default __exports__